import styled from 'vue-styled-components';

import theme from '@/config/theme';

export const IconButtonTypes = ['arrow-left', 'download', 'mail', 'print'] as const;

export const Wrapper = styled('button')`
  align-items: center;
  background-color: transparent;
  border: 1px solid #DEE1DB;
  border-radius: ${theme.border.radius.circle};
  cursor: pointer;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  transition: .25s border;
  width: 36px;

  &:hover {
    border-color: ${theme.colors.primaryBlue};
  }
`;
